"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dependencies = void 0;
class Dependencies {
    set acnVoucherDatastore(value) {
        this._acnVoucherDatastore = value;
    }
    get acnVoucherDatastore() {
        if (!this._acnVoucherDatastore) {
            throw new Error("acnVoucherDatastore not set.");
        }
        return this._acnVoucherDatastore;
    }
    set alertNotificationDatastore(value) {
        this._alertNotificationDatastore = value;
    }
    get alertNotificationDatastore() {
        if (!this._alertNotificationDatastore) {
            throw new Error("alertNotificationDatastore not set.");
        }
        return this._alertNotificationDatastore;
    }
    set alertNotificationSettingDatastore(value) {
        this._alertNotificationSettingDatastore = value;
    }
    get alertNotificationSettingDatastore() {
        if (!this._alertNotificationSettingDatastore) {
            throw new Error("_alertNotificationSettingDatastore not set.");
        }
        return this._alertNotificationSettingDatastore;
    }
    set analyticsEventDatastore(value) {
        this._analyticsEventDatastore = value;
    }
    get analyticsEventDatastore() {
        if (!this._analyticsEventDatastore) {
            throw new Error("analyticsEventDatastore not set.");
        }
        return this._analyticsEventDatastore;
    }
    set analyticsNewCustomerProfileDatastore(value) {
        this._analyticsNewCustomerProfileDatastore = value;
    }
    get analyticsNewCustomerProfileDatastore() {
        if (!this._analyticsNewCustomerProfileDatastore) {
            throw new Error("analyticsNewCustomerProfileDatastore not set.");
        }
        return this._analyticsNewCustomerProfileDatastore;
    }
    set analyticsNewDownloadDatastore(value) {
        this._analyticsNewDownloadDatastore = value;
    }
    get analyticsNewDownloadDatastore() {
        if (!this._analyticsNewDownloadDatastore) {
            throw new Error("analyticsNewDownloadDatastore not set.");
        }
        return this._analyticsNewDownloadDatastore;
    }
    set analyticsPushNotificationDatastore(value) {
        this._analyticsPushNotificationDatastore = value;
    }
    get analyticsPushNotificationDatastore() {
        if (!this._analyticsPushNotificationDatastore) {
            throw new Error("analyticsPushNotificationDatastore not set.");
        }
        return this._analyticsPushNotificationDatastore;
    }
    set alertDatastore(value) {
        this._alertDatastore = value;
    }
    get alertDatastore() {
        if (!this._alertDatastore) {
            throw new Error("alertDatastore not set.");
        }
        return this._alertDatastore;
    }
    set appDatastore(value) {
        this._appDatastore = value;
    }
    get appDatastore() {
        if (!this._appDatastore) {
            throw new Error("appDatastore not set.");
        }
        return this._appDatastore;
    }
    set appDetailDatastore(value) {
        this._appDetailDatastore = value;
    }
    get appDetailDatastore() {
        if (!this._appDetailDatastore) {
            throw new Error("appDetailDatastore not set.");
        }
        return this._appDetailDatastore;
    }
    set appDownloadPopUpDatastore(value) {
        this._appDownloadPopUpDatastore = value;
    }
    get appDownloadPopUpDatastore() {
        if (!this._appDownloadPopUpDatastore) {
            throw new Error("appDownloadPopUpDatastore not set.");
        }
        return this._appDownloadPopUpDatastore;
    }
    set appMessageDatastore(value) {
        this._appMessageDatastore = value;
    }
    get appMessageDatastore() {
        if (!this._appMessageDatastore) {
            throw new Error("appMessageDatastore not set.");
        }
        return this._appMessageDatastore;
    }
    set appVersionDatastore(value) {
        this._appVersionDatastore = value;
    }
    get appVersionDatastore() {
        if (!this._appVersionDatastore) {
            throw new Error("appVersionDatastore not set.");
        }
        return this._appVersionDatastore;
    }
    set authorizationTokenDatastore(value) {
        this._authorizationTokenDatastore = value;
    }
    get authorizationTokenDatastore() {
        if (!this._authorizationTokenDatastore) {
            throw new Error("authorizationTokenDatastore not set.");
        }
        return this._authorizationTokenDatastore;
    }
    set beaconDatastore(value) {
        this._beaconDatastore = value;
    }
    get beaconDatastore() {
        if (!this._beaconDatastore) {
            throw new Error("beaconDatastore not set.");
        }
        return this._beaconDatastore;
    }
    set binaryDatastore(value) {
        this._binaryDatastore = value;
    }
    get binaryDatastore() {
        if (!this._binaryDatastore) {
            throw new Error("binaryDatastore not set.");
        }
        return this._binaryDatastore;
    }
    set clientDatastore(value) {
        this._clientDatastore = value;
    }
    get clientDatastore() {
        if (!this._clientDatastore) {
            throw new Error("clientDatastore not set.");
        }
        return this._clientDatastore;
    }
    set customerDevicesDatastore(value) {
        this._customerDevicesDatastore = value;
    }
    get customerDevicesDatastore() {
        if (!this._customerDevicesDatastore) {
            throw new Error("customerDevicesDatastore not set.");
        }
        return this._customerDevicesDatastore;
    }
    set customerDocumentDatastore(value) {
        this._customerDocumentDatastore = value;
    }
    get customerDocumentDatastore() {
        if (!this._customerDocumentDatastore) {
            throw new Error("customerDocumentDatastore not set.");
        }
        return this._customerDocumentDatastore;
    }
    set customerProfileDatastore(value) {
        this._customerProfileDatastore = value;
    }
    get customerProfileDatastore() {
        if (!this._customerProfileDatastore) {
            throw new Error("customerProfileDatastore not set.");
        }
        return this._customerProfileDatastore;
    }
    set customerVehicleDatastore(value) {
        this._customerVehicleDatastore = value;
    }
    get customerVehicleDatastore() {
        if (!this._customerVehicleDatastore) {
            throw new Error("customerVehicleDatastore not set.");
        }
        return this._customerVehicleDatastore;
    }
    set customFormDatastore(value) {
        this._customFormDatastore = value;
    }
    get customFormDatastore() {
        if (!this._customFormDatastore) {
            throw new Error("customFormDatastore not set.");
        }
        return this._customFormDatastore;
    }
    set customFormFieldDatastore(value) {
        this._customFormFieldDatastore = value;
    }
    get customFormFieldDatastore() {
        if (!this._customFormFieldDatastore) {
            throw new Error("customFormFieldDatastore not set.");
        }
        return this._customFormFieldDatastore;
    }
    set departmentsDatastore(value) {
        this._departmentsDatastore = value;
    }
    get departmentsDatastore() {
        if (!this._departmentsDatastore) {
            throw new Error("departmentsDatastore not set.");
        }
        return this._departmentsDatastore;
    }
    set disabledFeatureDatastore(value) {
        this._disabledFeatureDatastore = value;
    }
    get disabledFeatureDatastore() {
        if (!this._disabledFeatureDatastore) {
            throw new Error("disabledFeatureDatastore not set.");
        }
        return this._disabledFeatureDatastore;
    }
    set getCurrentUtcDate(value) {
        this._getCurrentUtcDate = value;
    }
    get getCurrentUtcDate() {
        if (!this._getCurrentUtcDate) {
            throw new Error("getCurrentUtcDate not set.");
        }
        return this._getCurrentUtcDate;
    }
    set homeScreenTileDatastore(value) {
        this._homeScreenTileDatastore = value;
    }
    get homeScreenTileDatastore() {
        if (!this._homeScreenTileDatastore) {
            throw new Error("homeScreenTileDatastore not set.");
        }
        return this._homeScreenTileDatastore;
    }
    set importedCustomerProfileDatastore(value) {
        this._importedCustomerProfileDatastore = value;
    }
    get importedCustomerProfileDatastore() {
        if (!this._importedCustomerProfileDatastore) {
            throw new Error("importedCustomerProfileDatastore not set.");
        }
        return this._importedCustomerProfileDatastore;
    }
    set inventoryDealerIdDatastore(value) {
        this._inventoryDealerIdDatastore = value;
    }
    get inventoryDealerIdDatastore() {
        if (!this._inventoryDealerIdDatastore) {
            throw new Error("inventoryDealerIdDatastore not set.");
        }
        return this._inventoryDealerIdDatastore;
    }
    set inventoryDealerIdLocationDatastore(value) {
        this._inventoryDealerIdLocationDatastore = value;
    }
    get inventoryDealerIdLocationDatastore() {
        if (!this._inventoryDealerIdLocationDatastore) {
            throw new Error("inventoryDealerIdLocationDatastore not set.");
        }
        return this._inventoryDealerIdLocationDatastore;
    }
    set inventoryExternalSourceDatastore(value) {
        this._inventoryExternalSourceDatastore = value;
    }
    get inventoryExternalSourceDatastore() {
        if (!this._inventoryExternalSourceDatastore) {
            throw new Error("inventoryExternalSourceDatastore not set.");
        }
        return this._inventoryExternalSourceDatastore;
    }
    set inventoryProviderDatastore(value) {
        this._inventoryProviderDatastore = value;
    }
    get inventoryProviderDatastore() {
        if (!this._inventoryProviderDatastore) {
            throw new Error("inventoryProviderDatastore not set.");
        }
        return this._inventoryProviderDatastore;
    }
    set locationDatastore(value) {
        this._locationDatastore = value;
    }
    get locationDatastore() {
        if (!this._locationDatastore) {
            throw new Error("locationDatastore not set.");
        }
        return this._locationDatastore;
    }
    set locationManufacturerDatastore(value) {
        this._locationManufacturerDatastore = value;
    }
    get locationManufacturerDatastore() {
        if (!this._locationManufacturerDatastore) {
            throw new Error("locationManufacturerDatastore not set.");
        }
        return this._locationManufacturerDatastore;
    }
    set linkDatastore(value) {
        this._linkDatastore = value;
    }
    get linkDatastore() {
        if (!this._linkDatastore) {
            throw new Error("linkDatastore not set.");
        }
        return this._linkDatastore;
    }
    set loginDatastore(value) {
        this._loginDatastore = value;
    }
    get loginDatastore() {
        if (!this._loginDatastore) {
            throw new Error("loginDatastore not set.");
        }
        return this._loginDatastore;
    }
    set loyaltyRewardsLedgerEntryDatastore(value) {
        this._loyaltyRewardsLedgerEntryDatastore = value;
    }
    get loyaltyRewardsLedgerEntryDatastore() {
        if (!this._loyaltyRewardsLedgerEntryDatastore) {
            throw new Error("loyaltyRewardsLedgerEntryDatastore not set.");
        }
        return this._loyaltyRewardsLedgerEntryDatastore;
    }
    set loyaltyRewardsTasksDatastore(value) {
        this._loyaltyRewardsTasksDatastore = value;
    }
    get loyaltyRewardsTasksDatastore() {
        if (!this._loyaltyRewardsTasksDatastore) {
            throw new Error("loyaltyRewardsTasksDatastore not set.");
        }
        return this._loyaltyRewardsTasksDatastore;
    }
    set manufacturerFeedDatastore(value) {
        this._manufacturerFeedDatastore = value;
    }
    get manufacturerFeedDatastore() {
        if (!this._manufacturerFeedDatastore) {
            throw new Error("manufacturerFeedDatastore not set.");
        }
        return this._manufacturerFeedDatastore;
    }
    set manufacturerDatastore(value) {
        this._manufacturerDatastore = value;
    }
    get manufacturerDatastore() {
        if (!this._manufacturerDatastore) {
            throw new Error("manufacturerDatastore not set.");
        }
        return this._manufacturerDatastore;
    }
    set menuItemDatastore(value) {
        this._menuItemDatastore = value;
    }
    get menuItemDatastore() {
        if (!this._menuItemDatastore) {
            throw new Error("menuItemDatastore not set.");
        }
        return this._menuItemDatastore;
    }
    set navBarItemDatastore(value) {
        this._navBarItemsDatastore = value;
    }
    get navBarItemDatastore() {
        if (!this._navBarItemsDatastore) {
            throw new Error("navBarItemsDatastore not set.");
        }
        return this._navBarItemsDatastore;
    }
    set opentrackOperationCodeDatastore(value) {
        this._opentrackOperationCodeDatastore = value;
    }
    get opentrackOperationCodeDatastore() {
        if (!this._opentrackOperationCodeDatastore) {
            throw new Error("opentrackOperationCodesDatastore not set.");
        }
        return this._opentrackOperationCodeDatastore;
    }
    set passwordHasher(value) {
        this._passwordHasher = value;
    }
    get passwordHasher() {
        if (!this._passwordHasher) {
            throw new Error("passwordHasher not set.");
        }
        return this._passwordHasher;
    }
    set pushNotificationLogDatastore(value) {
        this._pushNotificationLogDatastore = value;
    }
    get pushNotificationLogDatastore() {
        if (!this._pushNotificationLogDatastore) {
            throw new Error("pushNotificationLogDatastore not set.");
        }
        return this._pushNotificationLogDatastore;
    }
    set roadsideNumberDatastore(value) {
        this._roadsideNumberDatastore = value;
    }
    get roadsideNumberDatastore() {
        if (!this._roadsideNumberDatastore) {
            throw new Error("roadsideNumberDatastore not set.");
        }
        return this._roadsideNumberDatastore;
    }
    set socialMediaFeedDatastore(value) {
        this._socialMediaFeedDatastore = value;
    }
    get socialMediaFeedDatastore() {
        if (!this._socialMediaFeedDatastore) {
            throw new Error("socialMediaFeedDatastore not set.");
        }
        return this._socialMediaFeedDatastore;
    }
    set staffMemberDatastore(value) {
        this._staffMemberDatastore = value;
    }
    get staffMemberDatastore() {
        if (!this._staffMemberDatastore) {
            throw new Error("staffMemberDatastore not set.");
        }
        return this._staffMemberDatastore;
    }
    set toolkitItemDatastore(value) {
        this._toolkitItemDatastore = value;
    }
    get toolkitItemDatastore() {
        if (!this._toolkitItemDatastore) {
            throw new Error("toolkitItemDatastore not set.");
        }
        return this._toolkitItemDatastore;
    }
    set userDatastore(value) {
        this._userDatastore = value;
    }
    get userDatastore() {
        if (!this._userDatastore) {
            throw new Error("userDatastore not set.");
        }
        return this._userDatastore;
    }
    set vehicleDropOffDatastore(value) {
        this._vehicleDropOffDatastore = value;
    }
    get vehicleDropOffDatastore() {
        if (!this._vehicleDropOffDatastore) {
            throw new Error("vehicleDropOffDatastore not set.");
        }
        return this._vehicleDropOffDatastore;
    }
    set vehicleDropOffMessageDatastore(value) {
        this._vehicleDropOffMessageDatastore = value;
    }
    get vehicleDropOffMessageDatastore() {
        if (!this._vehicleDropOffMessageDatastore) {
            throw new Error("vehicleDropOffMessageDatastore not set.");
        }
        return this._vehicleDropOffMessageDatastore;
    }
    set vehicleDropOffServiceItemDatastore(value) {
        this._vehicleDropOffServiceItemDatastore = value;
    }
    get vehicleDropOffServiceItemDatastore() {
        if (!this._vehicleDropOffServiceItemDatastore) {
            throw new Error("vehicleDropOffServiceItemDatastore not set.");
        }
        return this._vehicleDropOffServiceItemDatastore;
    }
    set vsmLastSentAlertDatastore(value) {
        this._vsmLastSentAlertDatastore = value;
    }
    get vsmLastSentAlertDatastore() {
        if (!this._vsmLastSentAlertDatastore) {
            throw new Error("vsmLastSentAlertDatastore not set.");
        }
        return this._vsmLastSentAlertDatastore;
    }
    set yearMakeModelDatastore(value) {
        this._yearMakeModelDatastore = value;
    }
    get yearMakeModelDatastore() {
        if (!this._yearMakeModelDatastore) {
            throw new Error("yearMakeModelDatastore not set.");
        }
        return this._yearMakeModelDatastore;
    }
}
exports.Dependencies = Dependencies;
//# sourceMappingURL=Dependencies.js.map